import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const QuerySubmitted = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryData = location.state || { name: "", email: "", message: "" };

  return (
    <div className="container  d-flex flex-column align-items-center justify-content-center text-center">
      <h2 className="fw-bold">Query Submitted Successfully!</h2>
      <p className="text-black fs-5">Thank you, {queryData.name}. Our team will get back to you soon.</p>
      <div className="card shadow p-4 text-start w-50">
        <p><strong>Name:</strong> {queryData.name}</p>
        <p><strong>Email:</strong> {queryData.email}</p>
        <p><strong>Message:</strong> {queryData.message}</p>
      </div>
      <Button className="mt-4" variant="dark" onClick={() => navigate("/help-center")}>
        Back to Help Center
      </Button>
    </div>
  );
};

export default QuerySubmitted;
